import { cn } from "@lib/cn";
import { IconAlertTriangle } from "@tabler/icons-react";

export const ErrorStateMessage = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        "tw-flex tw-flex-col tw-gap-2 tw-items-center tw-justify-center tw-h-full",
        className,
      )}
    >
      <IconAlertTriangle className="tw-size-6 tw-text-[#F59E0B]" />
      <p className="tw-font-sans tw-text-sm tw-font-semibold tw-text-blue tw-text-center">
        Failed to load data
      </p>
    </div>
  );
};
